export const PROJECT_DOMAINS = [
  'Santé',
  'Immobilier',
  'BTP',
  'IT / Développement Logiciel',
  'Éducation',
  'Finance',
  'Marketing',
  'Commerce / E-commerce',
  'Événementiel',
  'Juridique',
  'Industrie',
  'Art & Design',
  'Recherche & Développement',
  'Ressources Humaines',
  'Consulting',
  'Autre'
];

export const TEAM_ROLES = [
  'Développeur',
  'Designer',
  'Chef de Projet',
  'Product Owner',
  'Marketing',
  'Commercial',
  'Analyste',
  'Testeur / QA',
  'DevOps',
  'Architecte',
  'Consultant',
  'Directeur',
  'Assistant',
  'Stagiaire',
  'Autre'
];

export const ACCESS_LEVELS = [
  { value: 'admin', label: 'Admin (Accès complet)' },
  { value: 'editor', label: 'Membre (Modification)' },
  { value: 'viewer', label: 'Observateur (Lecture seule)' }
];
